export const NOTE_TYPE_AI = 'ai'

export type NoteType = 'new_leads_interest' | 'free_trial' | typeof NOTE_TYPE_AI

export type Type = 'reclaims' | 'requests' | 'salesLeads' | 'serviceProviders' | 'services'

export interface Note {
    class: string | null
    created: string
    foreign_key: number
    /** When the text was last edited; null when never edited. Pin toggles do not set it. */
    modified: string | null
    note: string
    note_id: number
    note_type: NoteType | null
    pinned: boolean
    type: Type
    user_id: number
}
